import { FilterSpecProps } from '@stores/audiences/types';
import { IDestinationStore } from '@stores/destination';
import { ISourceStore } from '@stores/source';
import { ISourceDefinition } from '@stores/sourceDefinitionsList';
import { PROFILE_SOURCE_TYPES } from '../../components/profiles/activation/stores/types';

export type RETLSourceType = BaseSourceType | PROFILE_SOURCE_TYPES;

export enum BaseSourceType {
  TABLE = 'table',
  MODEL = 'model',
  AUDIENCE = 'audience',
}
interface SqlModelConfig {
  description?: string;
  sql: string;
}

interface AudienceConfig {
  description?: string;
  filterSpec: FilterSpecProps;
}

interface ActivationConfig {
  cohort: string;
  entity: string;
  modelPath: string;
  schema: string;
  table: string;
  whtProjectId: string;
}

type TableConfig =
  | {
      schema: string;
      table: string;
    }
  | {
      prefix?: string;
      objectPrefix?: string;
      bucketName: string;
    };

export type ConfigType<T extends RETLSourceType> = {
  isCredentialsValidationSupported?: boolean;
} & (T extends BaseSourceType.MODEL
  ? SqlModelConfig
  : T extends BaseSourceType.AUDIENCE
  ? AudienceConfig
  : T extends PROFILE_SOURCE_TYPES.Audience
  ? ActivationConfig & AudienceConfig
  : T extends PROFILE_SOURCE_TYPES.Table
  ? ActivationConfig
  : TableConfig);

export interface RETLSource<T extends RETLSourceType> {
  oldSource?: ISourceStore;
  id: string;
  name: string;
  enabled: boolean;
  accountId: string;
  writeKey: string;
  createdAt: string;
  updatedAt: string;
  sourceDef: ISourceDefinition;
  updateDestinationIds: (ids: string[]) => void;
  destinations: IDestinationStore[];
  sourceType: T;
  sourceDefinitionName: string;
  config: ConfigType<T>;
  primaryKey?: string;
}

export type UpdateRETLSourceRequest<T extends RETLSourceType> = Partial<
  Pick<RETLSource<T>, 'name' | 'enabled' | 'accountId' | 'primaryKey'>
> & { config?: Partial<ConfigType<T>> };

export type CreateRETLSourceRequest<T extends RETLSourceType> = Pick<
  RETLSource<T>,
  'config' | 'sourceDefinitionName' | 'sourceType' | 'name' | 'accountId' | 'primaryKey'
>;
